import { render, staticRenderFns } from "./LogDetails.vue?vue&type=template&id=00ff08b0&scoped=true&"
import script from "./LogDetails.vue?vue&type=script&lang=js&"
export * from "./LogDetails.vue?vue&type=script&lang=js&"
import style0 from "./LogDetails.vue?vue&type=style&index=0&id=00ff08b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff08b0",
  null
  
)

export default component.exports